import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Title,
  Tooltip
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';

type DataSetProps = {
  label: string;
  data: string[] | number[];
  color: string;
};

type ChartComponentProps = {
  title: string;
  labels: string[];
  datasets: DataSetProps[];
};

export const BarChartComponent = ({
  title,
  labels,
  datasets
}: ChartComponentProps) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    ChartDataLabels
  );

  const options = {
    responsive: true,
    layout: {
      padding: {
        top: 80,
        left: 40,
        right: 40
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        grace: '20%',
        ticks: {
          display: true
        }
      }
    },
    categoryPercentage: 0.8,
    barPercentage: 1,
    plugins: {
      title: {
        display: false
      },
      datalabels: {
        display: false,
        formatter: (value: number) => {
          return 'R$ \n' + value.toLocaleString();
        },
        textAlign: 'center' as const
      }
    }
  };

  const data = {
    labels,
    datasets: datasets.map(({ data, label, color }) => {
      return {
        label,
        data,
        backgroundColor: color,
        borderRadius: 5,
        // barThickness: 30,
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: '#000'
        } as const
      };
    })
  };

  return <Bar options={options} data={data} />;
};
